import React from "react";
import { IWhen } from "@/types/ui.types";
export const When: React.FC<IWhen> = ({
  condition,
  children
}) => {
  return condition ? children : null;
};